/* eslint-disable default-case */
import {
  Pagination,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableSortLabel,
} from "@mui/material";
import FullScreenLoader from "app/components/ListingPageLoader";
import { displayDateFun } from "app/utils/constants/functions";
import { useState } from "react";
import { useSelector } from "react-redux";
export default function ShopOrderSalesTable() {
  const [order, setOrder] = useState("");
  const [orderBy, setOrderBy] = useState("fabric_code");
  const { shopSales, error, loading } = useSelector((state) => state.reportReducer);
  const handleSort = (property) => {
    const isAscending = orderBy === property && order === "asc";
    setOrder(isAscending ? "desc" : "asc");
    setOrderBy(property);
  };

  const sortedData = shopSales?.sort((a, b) => {
    let aValue;
    let bValue;
    if (orderBy == "shop_order_port_no_and_name") {
      aValue = a.shop_order_port_no_and_name.toLowerCase();
      bValue = b.shop_order_port_no_and_name.toLowerCase();
    } else if (orderBy == "shop_order_item_name") {
      aValue = a.shop_order_item_name.toLowerCase();
      bValue = b.shop_order_item_name.toLowerCase();
    } else if (orderBy == "shop_order_item_size") {
      aValue = a.shop_order_item_size.toLowerCase();
      bValue = b.shop_order_item_size.toLowerCase();
    } else if (orderBy == "created_by") {
      aValue = a.created_by.toLowerCase();
      bValue = b.created_by.toLowerCase();
    } else if (orderBy === "shop_order_no") {
      aValue = a.shop_order_no.toString().toLowerCase();
      bValue = b.shop_order_no.toString().toLowerCase();
    } else {
      aValue = a[orderBy];
      bValue = b[orderBy];
    }
    if (order === "desc") {
      return aValue < bValue ? -1 : 1;
    } else {
      return bValue < aValue ? -1 : 1;
    }
  });

  return (
    <>
      {loading && <FullScreenLoader />}
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ bgcolor: "#202020", color: "white" }}>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_order_no"}
                  direction={order}
                  onClick={() => handleSort("shop_order_no")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Order No
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_order_date"}
                  direction={order}
                  onClick={() => handleSort("shop_order_date")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Order Date
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_order_port_no_and_name"}
                  direction={order}
                  onClick={() => handleSort("shop_order_port_no_and_name")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Port No & Name
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_order_client_name"}
                  direction={order}
                  onClick={() => handleSort("shop_order_client_name")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Client Name
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_salesman_name"}
                  direction={order}
                  onClick={() => handleSort("shop_salesman_name")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Sales Person Name
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_order_item_name"}
                  direction={order}
                  onClick={() => handleSort("shop_order_item_name")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Item Name
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "145px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_order_item_size"}
                  direction={order}
                  onClick={() => handleSort("shop_order_item_size")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Item Size
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_order_item_require_quantity"}
                  direction={order}
                  onClick={() => handleSort("shop_order_item_require_quantity")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Order Qty
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "150px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "finished_invoice_date"}
                  direction={order}
                  onClick={() => handleSort("finished_invoice_date")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Invoice Date
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_order_awb_bl_no"}
                  direction={order}
                  onClick={() => handleSort("shop_order_awb_bl_no")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  AWB/BL NO
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "dispatch_shipment_no"}
                  direction={order}
                  onClick={() => handleSort("dispatch_shipment_no")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Shipment No
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "shop_order_dispatch_delivery_date"}
                  direction={order}
                  onClick={() => handleSort("shop_order_dispatch_delivery_date")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Date of Shipment
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "created_by"}
                  direction={order}
                  onClick={() => handleSort("created_by")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Created By
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "cost_price_supplier_cost"}
                  direction={order}
                  onClick={() => handleSort("cost_price_supplier_cost")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Supplier Cost
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "cost_price_addOns_cost"}
                  direction={order}
                  onClick={() => handleSort("cost_price_addOns_cost")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  AddOns Cost
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "cost_price_suit_cover_cost"}
                  direction={order}
                  onClick={() => handleSort("cost_price_suit_cover_cost")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Suit Cover Price
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "cost_price_other_charges"}
                  direction={order}
                  onClick={() => handleSort("cost_price_other_charges")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Other Charges
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "cost_price_remark"}
                  direction={order}
                  onClick={() => handleSort("cost_price_remark")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Remark
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "cost_price_quantity"}
                  direction={order}
                  onClick={() => handleSort("cost_price_quantity")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  QTY
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "cost_price_rate"}
                  direction={order}
                  onClick={() => handleSort("cost_price_rate")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Rate
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "cost_price_freight"}
                  direction={order}
                  onClick={() => handleSort("cost_price_freight")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Freight
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "cost_price_freight_remark"}
                  direction={order}
                  onClick={() => handleSort("cost_price_freight_remark")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Freight Remarks
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "total_cost_price"}
                  direction={order}
                  onClick={() => handleSort("total_cost_price")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Total Cost 
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_item_price"}
                  direction={order}
                  onClick={() => handleSort("selling_price_item_price")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Item Price (USD)
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "usd_rate"}
                  direction={order}
                  onClick={() => handleSort("usd_rate")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  USD Rate
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_item_price_in_INR"}
                  direction={order}
                  onClick={() => handleSort("selling_price_item_price_in_INR")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Item Price (INR)
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_addOns_price"}
                  direction={order}
                  onClick={() => handleSort("selling_price_addOns_price")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Add Ons Price
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_freight"}
                  direction={order}
                  onClick={() => handleSort("selling_price_freight")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Freight
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_freight_remark"}
                  direction={order}
                  onClick={() => handleSort("selling_price_freight_remark")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Freight Remarks
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_other_charges"}
                  direction={order}
                  onClick={() => handleSort("selling_price_other_charges")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Other Charges
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "selling_price_remark"}
                  direction={order}
                  onClick={() => handleSort("selling_price_remark")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Remarks
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "total_selling_price"}
                  direction={order}
                  onClick={() => handleSort("total_selling_price")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Total Selling Price
                </TableSortLabel>
              </TableCell>
              <TableCell
                sx={{
                  textAlign: "left",
                  minWidth: "120px",
                  verticalAlign: "middle",
                }}
              >
                <TableSortLabel
                  active={orderBy === "profit"}
                  direction={order}
                  onClick={() => handleSort("profit")}
                  sx={{
                    color: "white",
                    "&:hover": { color: "white" },
                    "&.MuiTableSortLabel-root.Mui-active": {
                      color: "white",
                    },
                  }}
                >
                  Profit
                </TableSortLabel>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {sortedData && sortedData.length > 0 ? (
              sortedData.map((row, i) => (
                <TableRow key={i}>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.shop_order_no}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {displayDateFun(row?.shop_order_date)}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.shop_order_port_no_and_name}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.shop_order_client_name}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.shop_salesman_name}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.shop_order_item_name}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.shop_order_item_size}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.shop_order_item_require_quantity}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {displayDateFun(row?.finished_invoice_date)}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.shop_order_awb_bl_no ? row?.shop_order_awb_bl_no : " -"}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.dispatch_shipment_no}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {displayDateFun(row?.shop_order_dispatch_delivery_date)}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.created_by}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.cost_price_supplier_cost}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.cost_price_addOns_cost || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.cost_price_suit_cover_cost || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.cost_price_other_charges || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.cost_price_remark || "-"}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.cost_price_quantity || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "left" }}>
                    {row?.cost_price_rate || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.cost_price_freight || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.cost_price_freight_remark || "-"}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.total_cost_price || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.selling_price_item_price || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.usd_rate || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.selling_price_item_price_in_INR || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.selling_price_addOns_price || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.selling_price_freight || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.selling_price_freight_remark || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.selling_price_other_charges || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.selling_price_remark || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.total_selling_price || 0}
                  </TableCell>
                  <TableCell sx={{ textAlign: "center", px: 1 }}>
                    {row?.profit || 0}
                  </TableCell>

                  
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell
                  colSpan={20}
                  sx={{ textAlign: "center", fontWeight: "bold" }}
                >
                  Data not found
                </TableCell>
              </TableRow>
            )}
            {/* {sortedData && sortedData.length > 0 && (
              <TableRow sx={{ fontWeight: "bold" }}>
                <TableCell
                  colSpan={14}
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  Total :
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.rawManuallyIssueQuantitySum}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.rawManuallyIssueTotalCost}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.fabricUsedSum}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.fabricPurchaseCostSum}
                </TableCell>

                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.totalFabricCostSum}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.otherCostJobWorkSum}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.jobworkCostWithoutGstSum}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.freightSum}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.addOnsPriceSum}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.suitcoverSum}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.opCostSum}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.totalCostSum}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.handlingCostSum}
                </TableCell>
                <TableCell
                  sx={{ textAlign: "left", fontWeight: "bold", fontSize: 15 }}
                >
                  {sortedData[0]?.grandTotalCostSum}
                </TableCell>
              </TableRow>
            )} */}
          </TableBody>
        </Table>
        <Pagination
          count={0}
          hidePrevButton
          hideNextButton
          hideEllipsis
          sx={{
            position: "sticky",
            bottom: 0,
            left: 0,
            backgroundColor: "white",
            borderTop: "1px solid #ddd",
            height: "40px",
          }}
        />
      </TableContainer>
    </>
  );
}
